export enum SenderType {
  HUMAN = 'HUMAN',
  BOT = 'BOT',
}

export interface CopilotMessageContent {
  text: string
}

export interface CopilotMessageDto {
  id?: number
  content: CopilotMessageContent
  senderType: SenderType
  createdAt: string
}

export interface CreateCopilotMessageBody {
  content: CopilotMessageContent
  senderType: SenderType
}
